import React, {
  useState,
  useContext,
  useEffect,
  Suspense
} from "react";

import loadable from "@loadable/component";

import { ThemeContext } from "../../../context/ThemeContext";
import InvoiceCard from "../Dompet/Home/InvoiceCard";
import CardBlog from "../Dompet/Home/CardBlog";
import AdminServices from "../../../services/AdminServices";

import POPendingSummaryCard from "./POPendingSummaryCard";
import MRVPendingSummaryCard from "./MRVPendingSummaryCard";
import RequisitionPendingSummaryCard from "./RequisitionPendingSummaryCard";
import RepairPOPendingSummaryCard from "./RepairPOPendingSummaryCard";
import PhysicalBillTrackingCard from "./PhysicalBillTrackingCard";
import PaymentPendingSummaryCard from "./PaymentPendingSummaryCard";
import Home3 from "./Home3";

const RequestDataModal = React.lazy(() =>
  import("./RequestDataModal")
);

const POPendingModal = React.lazy(() =>
  import("./POPendingModal")
);

const PaymentActionDashboardModal = React.lazy(() =>
  import("./PaymentActionDashboardModal")
);

const PaymentActionBillingModal = React.lazy(() =>
  import("./PaymentActionBillingModal")
);

const MaterialReceivingDashboardModal = React.lazy(() =>
  import("./MaterialReceivingDashboardModal")
);

const PWOPendingModal = React.lazy(() =>
  import("./RWOPendingModal")
);

const PhysicalBillTrackingDashboard = React.lazy(() =>
  import("./PhysicalBillTrackingDashboard")
);

const AccountsDashboardModal = React.lazy(() =>
  import("./AccountsDashboardModal")
);

let isPreloaded = false;

const preloadRequestModal = () => {
  if (!isPreloaded) {
    isPreloaded = true;

    import("./RequestDataModal").catch(() => {
      isPreloaded = false;
    });
  }
};

const ActivityApexBarGraph = loadable(() =>
  import("../Dompet/Home/ActivityApexBarGraph")
);

const MRVActivityApexBarGraph = loadable(() =>
  import("../Dompet/Home/mrvActivityApexGraph")
);

const TransferApexGraph = loadable(() =>
  import("../Dompet/Home/TransferApexGraph")
);

const MivActivityGraph = loadable(() =>
  import("../Dompet/Home/MivActivtyGraph")
);

const MtnActivityGraph = loadable(() =>
  import("../Dompet/Home/MtnActivityGraph")
);

const getDashboardPayload = (response) =>
  response?.data?.data || response?.data || response || {};

const Home2 = () => {
  const [showModal, setShowModal] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [modalType, setModalType] = useState(null);

  const [user] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem("userDetails") || "null"
      );
    } catch {
      return null;
    }
  });

  const role = user?.data?.user?.role || "";
  const normalizedRole = String(role).trim().toLowerCase();

  const {
    changeBackground,
    changeSideBarStyle,
    changePrimaryColor,
    chnageSidebarColor
  } = useContext(ThemeContext);

  const handleOpenModal = (type) => {
    if (type === "payment") {
      if (
        ["billing", "pomaker", "pochecker"].includes(
          normalizedRole
        )
      ) {
        setModalType("billingPayment");
      } else if (normalizedRole === "accounts") {
        setModalType("accountsPayment");
      } else {
        setModalType("payment");
      }
    } else {
      setModalType(type);
    }

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType(null);
  };

  useEffect(() => {
    let active = true;

    changeBackground({
      value: "light",
      label: "Light"
    });

    if (window.innerWidth >= 768) {
      changeSideBarStyle({
        value: "full",
        label: "full"
      });
    }

    changePrimaryColor("color_1");
    chnageSidebarColor("color_1");

    AdminServices.dashboard()
      .then((response) => {
        if (active) {
          const payload = getDashboardPayload(response);
          setDashboardData(payload);
        }
      })
      .catch((error) => {
        console.error("Dashboard loading failed:", error);
      });

    return () => {
      active = false;
    };

    // Apply dashboard theme and fetch counts on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Cash Flow — Accounts */}
      {normalizedRole === "accounts" && (
        <Home3 dashboardData={dashboardData} />
      )}

      {/* Requisition summary */}
      <div className="row">
        <div className="col-12">
          <RequisitionPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Purchase order summary */}
      <div className="row">
        <div className="col-12">
          <POPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Repair purchase order summary */}
      <div className="row">
        <div className="col-12">
          <RepairPOPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Material receiving summary */}
      <div className="row">
        <div className="col-12">
          <MRVPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Physical bill tracking */}
      <div className="row">
        <div className="col-12">
          <PhysicalBillTrackingCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Payment summary */}
      <div className="row">
        <div className="col-12">
          <PaymentPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Existing dashboard */}
      <div className="row invoice-card-row">
        <InvoiceCard
          data={dashboardData}
          onPendingClick={handleOpenModal}
          onMouseEnter={preloadRequestModal}
        />
      </div>

      {/* Row 1 */}
      <div className="row">
        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Requisition Voucher StoreWise -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmitted}
                </span>
              </h4>
            </div>

            <div className="card-body pt-3">
              <ActivityApexBarGraph
                storeWiseCounts={dashboardData?.storeWiseCounts}
              />
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Transfer Orders -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedTransfer}
                </span>
              </h4>
            </div>

            <div className="card-body pt-3">
              <TransferApexGraph
                storeWiseCounts={
                  dashboardData?.TranferStoreEiseCounts
                }
              />
            </div>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="row">
        <div className="col-xl-6 col-xxl-12">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Receipt Voucher -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedMrv}
                </span>
              </h4>
            </div>

            <div className="card-body pt-3">
              <MRVActivityApexBarGraph
                storeWiseCounts={
                  dashboardData?.mrvStoreEiseCounts
                }
              />
            </div>
          </div>
        </div>
      </div>

      {/* Row 3 */}
      <div className="row">
        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Issue Voucher -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedMiv}
                </span>
              </h4>
            </div>

            <div className="card-body pt-3">
              <MivActivityGraph
                storeWiseCounts={dashboardData?.MivStoreWise}
              />
            </div>
          </div>
        </div>

        <div className="col-xl-9 col-xxl-12">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Transfer Note -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.approvedMtn}
                </span>
              </h4>
            </div>

            <div className="card-body pt-3">
              <MtnActivityGraph
                storeWiseCounts={dashboardData?.MtnStoreWise}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Row 4 */}
      <div className="row">
        <div className="col-xl-6 col-xxl-12">
          <CardBlog
            totalRequestCompleted={
              dashboardData?.totalRequestcompleted
            }
            totalMivCompleted={dashboardData?.totalMIVcompleted}
            totalTransferCompleted={
              dashboardData?.totalTransfercompleted
            }
            totalMtncompleted={dashboardData?.totalMtncompleted}
            totalMrvcompleted={dashboardData?.totalMrvcompleted}
            requestTotal={dashboardData?.requestTotal}
            transferTotal={dashboardData?.transferTotal}
            mivTotal={dashboardData?.mivTotal}
            MtnTotal={dashboardData?.MtnTotal}
            MrvTotal={dashboardData?.MrvTotal}
          />
        </div>
      </div>

      {/* Modals */}
      {showModal && (
        <Suspense
          fallback={
            <div className="text-center py-3" role="status">
              Loading…
            </div>
          }
        >
          {modalType === "request" && (
            <RequestDataModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "po" && (
            <POPendingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "payment" && (
            <PaymentActionDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              userRole={role}
            />
          )}

          {modalType === "billingPayment" && (
            <PaymentActionBillingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "accountsPayment" && (
            <AccountsDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              userRole={role}
            />
          )}

          {modalType === "mrv" && (
            <MaterialReceivingDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              stores={dashboardData?.stores}
              userRole={role}
              totalPO={
                dashboardData?.totalPendingPOReceiving || 0
              }
              totalLocal={
                dashboardData?.totalPendingLocalReceiving || 0
              }
            />
          )}

          {modalType === "pwo" && (
            <PWOPendingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "physicalBill" && (
            <PhysicalBillTrackingDashboard
              show={showModal}
              handleClose={handleCloseModal}
              stores={dashboardData?.stores}
              userRole={role}
            />
          )}
        </Suspense>
      )}
    </>
  );
};

export default Home2;